import React from "react";
import { Link } from "react-router-dom";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";

const cards = [
  {
    imgsrc: "/img/educational/university.png",
    title: "Utah Universities",
    value: "36(2024)",
    link: "/utah-at-a-glance/universities-and-schools/utah-universities",
  },
  {
    imgsrc: "/img/educational/school.png",
    title: "Schools in Utah",
    value: "School District 41 (2023) Number of Schools : 956",
    link: "/utah-at-a-glance/universities-and-schools/utah-schools",
  },
  {
    imgsrc: "/img/educational/school.png",
    title: "Chartered Schools",
    value: "Explore charter schools by county in Utah",
    link: "/utah-at-a-glance/universities-and-schools/utah-schools/charter-schools",
  },
];

const EducationResources = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
      {/* Landing Section */}
      <LandingSection
        data={{
          imageName: "eduandresource.webp",
          title: "Universities and Schools",
        }}
      />

      <div className="mt-[2rem] p-4 flex flex-wrap justify-center items-center gap-6">
        {cards.map((item, index) => (
          <Link
            key={index}
            to={item.link}
            className="block w-full sm:w-3/4 md:w-1/2 lg:w-1/3 xl:w-1/4 no-underline"
          >
            <div className="relative p-8 min-h-[320px] flex flex-col justify-center items-center text-center overflow-hidden rounded-2xl shadow-lg bg-orange-100 hover:shadow-2xl hover:scale-105 transform transition duration-300">
              {/* Icon */}
              <div className="w-28 h-28 mb-6 flex items-center justify-center rounded-full bg-white shadow-md">
                <img
                  src={item.imgsrc}
                  alt={item.title}
                  className="w-20 h-20 object-contain"
                />
              </div>

              {/* Title */}
              <h2 className="text-2xl font-bold mb-3 text-indigo-900 tracking-wide">
                {item.title}
              </h2>

              {/* Value */}
              <p className="text-lg text-indigo-700 font-medium">
                {item.value}
              </p>
            </div>
          </Link>
        ))}
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default EducationResources;
